// extracted by css-extract-rspack-plugin
export default {"component":"Controls-module__component___I6VSl"};